<style lang="scss">
@import "./sass/main.scss";
</style>

<script>
export default {
  name: "Main"
}
</script>
